import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/auth/authSlice'
import audioPlayerReducer from './features/audioPlayer/audioPlayerSlice'
import persistUserProfileInfoConfigReducer from './features/UserProfileInfo/UserProfileInfoSlice'
import searchReducer from './features/search/searchSlice';
import chatReducer from './features/chat/chatSlice';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage'

import {
    persistReducer,
    persistStore,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist'

// import storage from 'redux-persist/lib/storage';
import { baseApi } from './api/baseApi';

const createNoopStorage = () => {
    return {
        getItem(_key) {
            return Promise.resolve(null);
        },
        setItem(_key, value) {
            return Promise.resolve(value);
        },
        removeItem(_key) {
            return Promise.resolve();
        }
    }
}

const storage = typeof window !== "undefined" ? createWebStorage("local") : createNoopStorage()

const persistConfig = {
    key: 'auth',
    storage
}

const persistUserProfileInfoConfig = {
    key: 'userProfileInfo',
    storage
}

const persistAudioPlayerConfig = {
    key: 'audioPlay',
    storage
}


const persistanceAuthReducer = persistReducer(persistConfig, authReducer);
const persistanceProfileReducer = persistReducer(persistUserProfileInfoConfig, persistUserProfileInfoConfigReducer);
const persistanceAudioReducer = persistReducer(persistAudioPlayerConfig, audioPlayerReducer);



export const store = configureStore({
    reducer: {
        auth: persistanceAuthReducer,
        userProfileInfo: persistanceProfileReducer,
        audioPlay: persistanceAudioReducer,
        search: searchReducer,
        chat: chatReducer,
        [baseApi.reducerPath]: baseApi.reducer,
    },
    middleware: getDefaultMiddlewares => getDefaultMiddlewares({
        serializableCheck: {
            ignoredActions: [FLUSH,
                REHYDRATE,
                PAUSE,
                PERSIST,
                PURGE,
                REGISTER]
        }
    }).concat(baseApi.middleware)
})



export const persistor = persistStore(store);